import { FC, useState } from "react";
import { StatusTagItem, StatusTagsContainer, StatusTagsHoverPopup, StatusTagItemWrap } from "./styles";
import { API, Lang, Status, Tag } from "@brg/api";
import { Skeleton } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { bTag } from "core";
import { BTag } from "core/components/bTag/bTag";
import { BTagsGridNew } from "core/components/bTag/bTagsGridNew/bTagsGridNew";
import { CreateLinkTo } from "shared/constants/linkTo";

export const StatusTagsComponent: FC<{ statusTags: Status[], isLoadingStatusTags: boolean }> = ({ statusTags, isLoadingStatusTags }) => {
    const { i18n: { language } } = useTranslation();
    const [hoveredStatusId, setHoveredStatusId] = useState<string | null>(null);

    if (isLoadingStatusTags) {
        return <Skeleton width={68} height={20} />
    }

    return (
        <StatusTagsContainer onMouseLeave={() => setHoveredStatusId(null)}>
            {statusTags.map((status) => (
                <StatusTagItemWrap
                    key={status.id}
                    onMouseEnter={() => setHoveredStatusId(status.id)}
                >
                    <StatusTagItem>
                        {Lang(status.name, language)}
                    </StatusTagItem>
                    {hoveredStatusId === status.id && !!status.tags?.length && (
                        <StatusTagsHoverPopup>
                            <BTagsGridNew style={{ marginBottom: 0 }} noLimitMaxHeight>
                                {status.tags.map((tag) => {
                                    const translatedTag = API.toLang<Tag<'Local'>>(tag, language)
                                    return (
                                        <BTag
                                            key={translatedTag.tagId}
                                            tag={translatedTag}
                                            educational={translatedTag?.isEducationTag}
                                            organization={translatedTag?.isTeamTag}
                                            onClick={() => window.open(CreateLinkTo.tag(translatedTag.tagId), '_blank')}
                                            isShort
                                        >
                                            {bTag.title(translatedTag)}
                                        </BTag>
                                    )
                                })}
                            </BTagsGridNew>
                        </StatusTagsHoverPopup>
                    )}
                </StatusTagItemWrap>
            ))}
        </StatusTagsContainer>
    )
}
import { FC, useState } from "react";
import { StatusTagItem, StatusTagsContainer, StatusTagsHoverPopup, StatusTagItemWrap } from "./styles";
import { API, Lang, Status, Tag } from "@brg/api";
import { Skeleton } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { bTag } from "core";
import { BTag } from "core/components/bTag/bTag";
import { BTagsGridNew } from "core/components/bTag/bTagsGridNew/bTagsGridNew";
import { CreateLinkTo } from "shared/constants/linkTo";

export const StatusTagsComponent: FC<{ statusTags: Status[], isLoadingStatusTags: boolean }> = ({ statusTags, isLoadingStatusTags }) => {
    const { i18n: { language } } = useTranslation();
    const [hoveredStatusId, setHoveredStatusId] = useState<string | null>(null);

    if (isLoadingStatusTags) {
        return <Skeleton width={68} height={20} />
    }

    return (
        <StatusTagsContainer onMouseLeave={() => setHoveredStatusId(null)}>
            {statusTags.map((status) => (
                <StatusTagItemWrap
                    key={status.id}
                    onMouseEnter={() => setHoveredStatusId(status.id)}
                >
                    <StatusTagItem>
                        {Lang(status.name, language)}
                    </StatusTagItem>
                    {hoveredStatusId === status.id && !!status.tags?.length && (
                        <StatusTagsHoverPopup>
                            <BTagsGridNew style={{ marginBottom: 0 }} noLimitMaxHeight>
                                {status.tags.map((tag) => {
                                    const translatedTag = API.toLang<Tag<'Local'>>(tag, language)
                                    return (
                                        <BTag
                                            key={translatedTag.tagId}
                                            tag={translatedTag}
                                            educational={translatedTag?.isEducationTag}
                                            organization={translatedTag?.isTeamTag}
                                            onClick={() => window.open(CreateLinkTo.tag(translatedTag.tagId), '_blank')}
                                            isShort
                                        >
                                            {bTag.title(translatedTag)}
                                        </BTag>
                                    )
                                })}
                            </BTagsGridNew>
                        </StatusTagsHoverPopup>
                    )}
                </StatusTagItemWrap>
            ))}
        </StatusTagsContainer>
    )
}
